import store from "@/store"
export default {
  computed: {
    ...store.mapState({
      requestForHomeHide: 'common.requestForHomeHide',
    }),
  },
  methods: {
    ...store.mapActions({
      accPacStatusUpdate: 'coupon.accPacStatusUpdate'
    }),
    ...store.mapMutations({
      setRequestForHomeHide: 'common.setRequestForHomeHide'
    })
  },
  onShow() {
    if(this.requestForHomeHide) {
      this.setRequestForHomeHide(false)
      this.accPacStatusUpdate() 
    }
  }
}